import { useFormContext } from 'react-hook-form';

import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import { faCheckCircle, faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

import { InputMessageContainer } from './styled/InputCommon.styled';
import * as S from './styled/ViewField.styled';

const ViewField = (props) => {
	const { name } = props;

	return name ? <FormComponent {...props} /> : <GlobalComponent {...props} />;
};

const FormComponent = (props) => {
	const { name } = props;
	const formMethods = useFormContext();

	return (
		<CoreComponent
			{...props}
			viewValue={formMethods?.getValues(name) || '-'}
			errorMessage={formMethods?.getFieldState(name, formMethods?.formState)?.error?.message}
		/>
	);
};

const GlobalComponent = (props) => <CoreComponent {...props} viewValue={props.value || '-'} />;

const CoreComponent = (props) => {
	const {
		component,
		viewValue,
		customValue,
		disabled,
		viewMode,
		autoTranslation = true,
		successMessage,
		errorMessage
	} = props;

	return disabled && !viewMode ? (
		<>
			<S.Container className={`disabled-view-field ${customValue ? 'custom-disabled-field' : ''}`}>
				{customValue ? (
					customValue
				) : (
					<Typography
						noWrap={component === 'textarea'}
						color="var(--content-4)"
						autoTranslation={autoTranslation}>
						{viewValue}
					</Typography>
				)}
			</S.Container>
			{successMessage && (
				<InputMessageContainer className="view-field-success-message-container">
					<Icon icon={faCheckCircle} color="var(--green)" size="x-small" />
					<Typography variant="caption" fontWeight="500" color="var(--green)" noWrap>
						{successMessage}
					</Typography>
				</InputMessageContainer>
			)}
			{errorMessage && (
				<InputMessageContainer className="view-field-error-message-container">
					<Icon icon={faExclamationCircle} color="var(--red)" size="x-small" />
					<Typography variant="caption" fontWeight="500" color="var(--red)" noWrap>
						{errorMessage}
					</Typography>
				</InputMessageContainer>
			)}
		</>
	) : (
		<Typography className="view-field" autoTranslation={autoTranslation}>
			{viewValue}
		</Typography>
	);
};

export default ViewField;
